class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant){
      this.updateSliderCounter();
      return;
    } 
    const currentMedia = document.querySelector(
      `.product__media-item.current-variant`
    );

    if(!this.currentVariant?.featured_media){
      const variantMedia = document.querySelectorAll(
        `.product__media-item.variant-image`
      );
      variantMedia.forEach((variant) => {
        variant.classList.add("hidden");
        variant.classList.remove("current-variant");
      })
      this.updateSliderCounter();
      return;
    }
    
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia){
      this.updateSliderCounter();
      return;
    } 

    newMedia.classList.add('current-variant');
    newMedia.classList.remove('hidden');

    if(currentMedia){
      currentMedia.classList.remove('current-variant');
      currentMedia.classList.add('hidden');
    }

    const parent = newMedia.parentElement;
    parent.classList.toggle('changed');
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });

    
    this.updateSliderCounter();

    
    
  }
  updateSliderCounter(){
    const visibleMedia = document.querySelectorAll(".product__media-item:not(.hidden)");
    const sliderCounter = document.querySelector(".slider-buttons");

    if(!sliderCounter) return
    
    if(visibleMedia.length == 1){
      sliderCounter.classList.add('hidden');
    }else{
      sliderCounter.classList.remove('hidden');
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    const allProductForms = document.querySelectorAll('form[action*="/cart/add"]');
    allProductForms.forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const standardPriceElement = document.getElementById(`price-${this.dataset.section}`);
    const customPriceElements = document.querySelectorAll(`[data-price-section="${this.dataset.section}"]`);
    const standardGalleryElement = document.getElementById(`gallery-${this.dataset.section}`);
    const variantMetafieldElements = document.querySelectorAll(`[data-variant-metafield="${this.dataset.section}"]`);
    
    if (standardPriceElement) {
      standardPriceElement.classList.add('loading');
    }
    
    customPriceElements.forEach(el => {
      if (el) el.classList.add('loading');
    });

    if (standardGalleryElement) {
      standardGalleryElement.classList.add('loading');
    }

    variantMetafieldElements.forEach(el => {
      if (el) el.classList.add('loading');
    });

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (standardPriceElement) {
          this.replaceInfo(`price-${this.dataset.section}`, responseText);
          standardPriceElement.classList.remove('visibility-hidden');
        }
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        customPriceElements.forEach(priceElement => {
          const priceId = priceElement.id;
          const sourcePrice = html.getElementById(priceId);
          
          if (sourcePrice && priceElement) {
            priceElement.innerHTML = sourcePrice.innerHTML;
          }
          priceElement.classList.remove('loading');
          priceElement.classList.remove('visibility-hidden');
        });
        
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        if (standardGalleryElement) {
          this.replaceInfo(`gallery-${this.dataset.section}`, responseText);
        }

        variantMetafieldElements.forEach(metafieldElement => {
          const metafieldId = metafieldElement.id;
          const sourceMetafield = html.getElementById(metafieldId);

          if (sourceMetafield && metafieldElement) {
            metafieldElement.innerHTML = sourceMetafield.innerHTML;
          }
          metafieldElement.classList.remove('loading');
        });
      })
      .catch((error) => {
        if (standardPriceElement) {
          standardPriceElement.classList.remove('loading');
        }

        customPriceElements.forEach(el => {
          if (el) el.classList.remove('loading');
        });

        if (standardGalleryElement) {
          standardGalleryElement.classList.remove('loading');
        }

        variantMetafieldElements.forEach(el => {
          if (el) el.classList.remove('loading');
        });
      });
  }

  replaceInfo(id, responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;

    destination.classList.remove('loading');
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    
    const standardPriceElement = document.getElementById(`price-${this.dataset.section}`);
    if (standardPriceElement) {
      standardPriceElement.classList.add('visibility-hidden');
    }
    
    const customPriceElements = document.querySelectorAll(`[data-price-section="${this.dataset.section}"]`);
    customPriceElements.forEach(el => {
      if (el) el.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    
    this.updateVariantAvailability();
  }
  
  updateVariantAvailability() {
    const variants = this.getVariantData();
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    fieldsets.forEach((fieldset, optionIndex) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      
      inputs.forEach((input) => {
        const optionValue = input.value;
        
        const isAvailable = variants.some((variant) => {
          if (variant.options[optionIndex] !== optionValue) {
            return false;
          }
          
          const matchesOtherOptions = this.options.every((selectedValue, selectedIndex) => {
            if (selectedIndex === optionIndex) return true; 
            return variant.options[selectedIndex] === selectedValue;
          });
          
          return matchesOtherOptions && variant.available;
        });
        
        input.disabled = !isAvailable;
        
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        if (label) {
          if (!isAvailable) {
            label.style.opacity = '0.5';
            label.style.cursor = 'not-allowed';
          } else {
            label.style.opacity = '1';
            label.style.cursor = 'pointer';
          }
        }
      });
    });
  }
}

customElements.define('variant-radios', VariantRadios);
